module.exports = __webpack_public_path__ + "static/aplicativoFlynowProdutividade-5b08a362991d9a9c36a7e6e0e83ac5f3.png";